import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './modules/auth/services/auth.service';
import { StorageService } from './shared/services/storage.service';
import { AUTH_TOKEN_KEY, HttpStatus } from './shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private storageService: StorageService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.storageService.getItem(AUTH_TOKEN_KEY);
    let request = req;

    // Solo incluir el token si existe y no es null
    if (token && token !== 'null') {
      request = req.clone({
        setHeaders: {
          [AUTH_TOKEN_KEY]: token,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatus.UNAUTHORIZED) {
          // Token inválido o expirado
          this.storageService.clear();
          this.authService.logout();
        }
        return throwError(() => error);
      })
    );
  }
}
